import { pgTable, uuid, text, timestamp, index } from "drizzle-orm/pg-core";

/**
 * Append-only TCPA consent records for SMS marketing.
 * Each row represents a consent grant or withdrawal event.
 * Records are immutable — never updated, only superseded by new entries.
 * Retention: 4 years per TCPA litigation requirements.
 */
export const smsConsentRecords = pgTable("sms_consent_records", {
  id: uuid("id").primaryKey().defaultRandom(),
  tenantId: uuid("tenant_id").notNull(),
  personId: uuid("person_id").notNull(),
  phone: text("phone").notNull(),  // E.164 format
  phoneHash: text("phone_hash").notNull(),  // SHA-256 for lookup without PII
  consentType: text("consent_type").notNull(),  // marketing_sms, transactional_sms
  action: text("action").notNull(),  // granted, withdrawn, re_granted

  // PEWC proof fields (mandatory for marketing SMS)
  disclosureText: text("disclosure_text"),  // exact consent language shown
  consumerAction: text("consumer_action"),  // checkbox, keyword_reply, form_submit, verbal
  sourceUrl: text("source_url"),  // URL where consent was captured
  ipAddressHash: text("ip_address_hash"),  // HMAC-SHA-256 hash of IP (IP_HASH_SECRET) — never store raw IP (GDPR Art. 4)
  userAgent: text("user_agent"),

  // For withdrawal
  withdrawalMethod: text("withdrawal_method"),  // stop_keyword, web_unsubscribe, api

  // Metadata
  policyVersion: text("policy_version"),
  createdAt: timestamp("created_at", { withTimezone: true }).defaultNow().notNull(),
  // Append-only: no updatedAt. Rows are never modified.
}, (table) => [
  index("idx_sms_consent_tenant_person").on(table.tenantId, table.personId),
  index("idx_sms_consent_phone_hash").on(table.phoneHash),
  index("idx_sms_consent_tenant_type").on(table.tenantId, table.consentType, table.action),
]);
